import {Button, Checkbox, Col, Form, Input, Modal, Row, Select, Space, Tag, Typography, Grid, Empty} from "antd";
import DatePicker from "../../../core/components/DatePicker";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import UnitSelectbox from "../../unit/UnitSelectbox";
import { useCalendar } from "./CalendarContext";
import { t } from "i18next";
import { isMobile } from 'react-device-detect'
import ApiService from "../../../core/service/ApiService";
import locale from 'antd/es/date-picker/locale/tr_TR';
import Helper from "../../../core/Helper";
import { CheckOutlined, CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";


export default function AppointmentFilter({ }) {
    const { filter, units, setUnits, setDate, setSelectedUnits, setSearchText, setHideDeletedAndCancelled } = useCalendar();
    const screens = Grid.useBreakpoint();
    const isMobileLayout = !screens.md;

    const [unitPickerOpen, setUnitPickerOpen] = useState(false);
    const [unitSearchText, setUnitSearchText] = useState('');

    const load = async () => {
        const res = await ApiService.Unit.GetUnitList();
        if (res.success) {
            setUnits(res.data)
        }
    }

    useEffect(() => {
        load()
    }, [])

    const toggleUnit = (unitId) => {
        const current = filter.selectedUnits || [];
        if (current.includes(unitId)) {
            setSelectedUnits(current.filter(x => x !== unitId));
        } else {
            setSelectedUnits([...current, unitId]);
        }
    };

    const filteredUnits = units.filter(u => {
        if (!unitSearchText) return true;
        const haystack = `${u?.firm?.name || ''} ${u.name || ''}`;
        return Helper.Text.normalizeText(haystack).includes(Helper.Text.normalizeText(unitSearchText));
    });

    const renderUnitSelector = () => {
        if (!isMobileLayout) {
            // Desktop: mevcut Select aynen
            return (
                <Select
                    onChange={(values) => setSelectedUnits(values)}
                    mode="tags"
                    maxTagCount={isMobile ? 'responsive' : 5}
                    value={filter.selectedUnits}
                    style={{ minWidth: 300 }}
                    placeholder={t('Units')}
                    virtual={false}
                >
                    {
                        units.map(u => {
                            return (
                                <Select.Option value={u.id} key={u.id}>
                                    <b>{u?.firm?.name}</b> -{u.name}
                                </Select.Option>
                            )
                        })
                    }
                </Select>
            );
        }

        // Mobile: sadece Button + Modal (chip listesi mobilde fazla dikey alan kapladığı için kaldırıldı;
        // seçili birimler buton üzerinde sayı olarak gösteriliyor, modal'da görülebiliyor)
        const selectedCount = filter.selectedUnits?.length || 0;
        return (
            <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', gap: 6 }}>
                    <Button
                        size="middle"
                        icon={<PlusOutlined />}
                        style={{ flex: 1 }}
                        onClick={() => {
                            setUnitSearchText('');
                            setUnitPickerOpen(true);
                        }}
                    >
                        {t('Units')} {selectedCount > 0 && `(${selectedCount} seçili)`}
                    </Button>
                    {selectedCount > 0 && (
                        <Button
                            danger
                            size="middle"
                            icon={<CloseOutlined />}
                            onClick={() => setSelectedUnits([])}
                            title={t('Clear Selected Units')}
                        />
                    )}
                </div>

                <Modal
                    title={(
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingRight: 24 }}>
                            <span>{t('Units')}</span>
                            <Tag color="blue" style={{ margin: 0 }}>{selectedCount} seçili</Tag>
                        </div>
                    )}
                    open={unitPickerOpen}
                    onCancel={() => setUnitPickerOpen(false)}
                    footer={null}
                    width={420}
                    centered
                    style={{ maxWidth: 'calc(100vw - 16px)' }}
                    bodyStyle={{
                        padding: 12,
                        maxHeight: '60vh',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}
                    destroyOnClose
                >
                    <Input
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        placeholder="Birim ara..."
                        size="middle"
                        value={unitSearchText}
                        onChange={(e) => setUnitSearchText(e.target.value)}
                        allowClear
                        autoFocus
                        style={{ marginBottom: 8 }}
                    />
                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        border: '1px solid #f0f0f0',
                        borderRadius: 4,
                        marginBottom: 8
                    }}>
                        {filteredUnits.length === 0 ? (
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={t('No Data')}
                                style={{ padding: 24 }}
                            />
                        ) : filteredUnits.map(u => {
                            const selected = (filter.selectedUnits || []).includes(u.id);
                            return (
                                <div
                                    key={u.id}
                                    onClick={() => toggleUnit(u.id)}
                                    style={{
                                        padding: '12px 10px',
                                        borderBottom: '1px solid #f5f5f5',
                                        backgroundColor: selected ? '#e6f7ff' : 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        cursor: 'pointer'
                                    }}
                                >
                                    <div style={{
                                        width: 22, height: 22,
                                        border: `2px solid ${selected ? '#1890ff' : '#d9d9d9'}`,
                                        borderRadius: 4,
                                        background: selected ? '#1890ff' : 'white',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: 'white', fontSize: 14, lineHeight: 1, flexShrink: 0
                                    }}>
                                        {selected && '✓'}
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        {u?.firm?.name && (
                                            <div style={{ fontSize: 11, color: '#8c8c8c' }}>
                                                {u.firm.name}
                                            </div>
                                        )}
                                        <div style={{ fontWeight: selected ? 600 : 400, fontSize: 14, wordBreak: 'break-word' }}>
                                            {u.name}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <Button
                        type="primary"
                        block
                        size="large"
                        onClick={() => setUnitPickerOpen(false)}
                    >
                        Tamam ({selectedCount})
                    </Button>
                </Modal>
            </div>
        );
    };

    if (isMobileLayout) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%' }}>
                {renderUnitSelector()}

                {/* Gün seçici tam satır genişliğinde — gün adı (ör. Cuma/Cumartesi) tam okunsun */}
                <DatePicker
                    locale={Helper.Date.getLocale()}
                    value={filter.date}
                    format={'DD/MM/yyyy, dddd'}
                    style={{ width: '100%', fontSize: 13 }}
                    onChange={(val) => setDate(val)}
                    allowClear={false}
                    inputReadOnly
                />
                <div style={{ display: 'flex', gap: 4 }}>
                    <Button
                        size="middle"
                        onClick={() => { setDate(moment(filter.date).add(-1, 'days')) }}
                        style={{ flex: 1 }}
                    >
                        {'<'}
                    </Button>
                    <Button
                        size="middle"
                        onClick={() => { setDate(moment(filter.date).add(1, 'days')) }}
                        style={{ flex: 1 }}
                    >
                        {'>'}
                    </Button>
                    <Button
                        type="primary"
                        size="middle"
                        onClick={() => { setDate(moment()) }}
                        style={{ flex: 1 }}
                    >
                        {t('Today')}
                    </Button>
                </div>

                {/* Silinen/iptalleri gizle — compact, en altta; büyük gri kutu kaldırıldı */}
                <Checkbox
                    checked={filter.hideDeletedAndCancelled}
                    onChange={(e) => setHideDeletedAndCancelled(e.target.checked)}
                    style={{ fontSize: 12 }}
                >
                    {t('Hide deleted and cancelled')}
                </Checkbox>
            </div>
        );
    }

    // Desktop layout (orijinal)
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 8,
                    alignItems: 'start'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'start', width: '100%', flexWrap: 'wrap', gap: 4 }}>
                    <Button
                        danger
                        icon={<CloseOutlined />}
                        disabled={!filter.selectedUnits?.length}
                        onClick={() => setSelectedUnits([])}
                        title={t('Clear Selected Units')}
                    />
                    {renderUnitSelector()}
                    <div style={{ padding: '4px 10px' }}>
                        <Checkbox
                            checked={filter.hideDeletedAndCancelled}
                            onChange={(e) => setHideDeletedAndCancelled(e.target.checked)}
                        >
                            {t('Hide deleted and cancelled')}
                        </Checkbox>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            gap: 4,
                            flexWrap: 'wrap'
                        }}
                    >
                        <DatePicker
                            locale={Helper.Date.getLocale()}
                            value={filter.date}
                            format={'DD/MM/yyyy, dddd'}
                            style={{ minWidth: 200, height: 28 }}
                            onChange={(val) => setDate(val)}
                        />
                        <Button
                            onClick={
                                () => { setDate(moment(filter.date).add(-1, 'days')) }
                            }
                        >
                            {'<'}
                        </Button>
                        <Button onClick={() => { setDate(moment(filter.date).add(1, 'days')) }}>{'>'}</Button>
                        <Button type={'primary'} onClick={() => { setDate(moment()) }}>{t('Today')}</Button>
                    </div>
                </div>
            </div>
        </>
    )
}
